// Add polyfills
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'nodelist-foreach-polyfill';

const DOMAIN = 'https://www.capio.org';
const PATH = '/user';
const SELECTOR = '.page';

export default class Import {
  constructor(element, callback) {
    this.element = element;
    this.callback = callback;
    this.fail = this.fail.bind(this);
    this.success = this.success.bind(this);

    const url = `${DOMAIN}${PATH}`;

    const options = {
      mode: 'cors',
      method: 'GET',
      cache: 'default',
      credentials: 'include',
    };

    // Request homepage.
    fetch(url, options)
      .then(this.validate)
      .then(this.success)
      .catch(this.fail);
  }

  // Validate response from our request.
  /* eslint-disable class-methods-use-this */
  validate(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  // Display an error message if the request failed.
  fail(error) {
    this.error = error;
  }

  success(result) {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(result, 'text/html');
    this.content = parsedDocument.querySelector(SELECTOR);
    this.prepImportedContent();
    this.injectImportedContent();
    this.callback();
  }

  prepImportedContent() {
    const sources = this.content.querySelectorAll('[src^="/"]');
    const actions = this.content.querySelectorAll('[action^="/"]');
    const references = this.content.querySelectorAll('[href^="/"]');
    this.makeAttributeAbsolute(sources, 'src');
    this.makeAttributeAbsolute(actions, 'action');
    this.makeAttributeAbsolute(references, 'href');
  }

  injectImportedContent() {
    const importedContent = this.content.querySelector('#content');
    const localContent = document.querySelector('#site-wrap');
    // Clear out the imported contents from main site.
    importedContent.innerHTML = '';
    // Replace contents with the main content of the MemberClicks page.
    importedContent.appendChild(localContent);
    // Plop down the imported content within the MemberClicks page.
    document.body.appendChild(this.content);
  }

  makeAttributeAbsolute(elements, attribute) {
    elements.forEach((element) => {
      const value = element.getAttribute(attribute);
      element.setAttribute(attribute, `${DOMAIN}${value}`);
    });
  }
}
